import React, { useEffect, useRef } from 'react';
import { Animated, StyleProp, ViewStyle } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { hexToRgbA } from '../../../utils/hexToRGBA';
import { colors } from '../../../utils/theme';

export type ProgressBarOwnProps = {
    style?: StyleProp<ViewStyle>;
    /**
     * value between 0 and 100
     */
    progress: number;
};

export type ProgressBarProps = ProgressBarOwnProps;

const linearGradientColors = [
    hexToRgbA(colors['Progress-Bar-Gradient-1'], 1),
    hexToRgbA(colors['Progress-Bar-Gradient-2'], 1),
];

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
    const validatedProgress = Math.min(100, Math.max(0, props.progress || 0));
    const invertedProgress = 100 - validatedProgress;
    const progressAnimationRef = useRef<Animated.Value>(new Animated.Value(invertedProgress));
    useEffect(() => {
        Animated.timing(progressAnimationRef.current, {
            toValue: invertedProgress,
            duration: 200,
            useNativeDriver: false,
        }).start();
    }, [invertedProgress]);

    return (
        <LinearGradient
            colors={linearGradientColors as any}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={[
                {
                    width: '100%',
                    height: 13,
                    borderRadius: 3,
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'relative',
                    overflow: 'hidden',
                    borderWidth: 1,
                    borderColor: colors['Dividers'],
                },
                props.style,
            ]}
        >
            <Animated.View
                style={{
                    height: 13,
                    right: 0,
                    position: 'absolute',
                    top: 0,
                    width: progressAnimationRef.current.interpolate({
                        inputRange: [0, 100],
                        outputRange: ['0%', '100%'],
                    }),
                    backgroundColor: colors['Grey-Light2'],
                }}
            />
        </LinearGradient>
    );
};

export default React.memo(ProgressBar);
